<template>
  <div>
    <!-- 视频 播报-->
    <div class="video">
      <video-player
        class="video-player vjs-custom-skin"
        id="video"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      >
      </video-player>
    </div>
    <div class="tab">
      <div class="tab-item" @click="tabSwitch(0)">
        <div :class="['tab-item-item', 'detail', tabIndex == 0 ? 'show' : '']">
          <p>往期视频</p>
          <img
            class="underline"
            src="../../static/projectBriefing/images/sp_01.png"
            alt=""
            v-if="tabIndex == 0"
          />
        </div>
        <!-- <div class="tab-item-item thumb">
          <div>
            <img
              class="icon"
              src="../../static/projectBriefing/images/sp_02.png"
              alt=""
            />
            <p>999</p>
          </div>
        </div> 
        <div class="tab-item-item share" @click="share">
          <img
            class="icon"
            src="../../static/projectBriefing/images/sp_03.png"
            alt=""
          />
        </div> -->
      </div>
      <div class="tab-item" @click="tabSwitch(1)">
        <div :class="['tab-item-item', 'detail', tabIndex == 1 ? 'show' : '']">
          <p>详情</p>
          <img
            class="underline"
            src="../../static/projectBriefing/images/sp_01.png"
            alt=""
            v-if="tabIndex == 1"
          />
        </div>

        <!-- <div class="tab-item-item comment" @click="login">
          <p>评论（999）</p>
        </div> -->
      </div>
    </div>

    <!-- 详情 -->
    <div class="detail" v-if="tabIndex == 1">
      <!-- 视频简介 -->
      <div class="desc">
        <div class="title">{{ video.video_title }}</div>
        <div class="intro">
          {{ video.video_desc }}
        </div>
      </div>
      <!-- 中间空白 -->
      <div class="none"></div>
      <!-- 喜欢本期 -->
      <div class="label">
        <div class="label-title">
          <div class="shu"></div>
          <div class="label-title-text">
            <p>喜欢本期</p>
          </div>
        </div>
        <div class="label-list">
          <ul>
            <li
              :class="['label-list-item', item.isSelected ? 'is-selected' : '']"
              v-for="(item, index) in likeList"
              :key="index"
              @click="chooseLabel('like', index)"
            >
              <p># {{ item.label_name }} #</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 中间空白 -->
      <div class="none"></div>
      <!-- 希望看到更多 -->
      <div class="label">
        <div class="label-title">
          <div class="shu"></div>
          <div class="label-title-text">
            <p>希望看到更多</p>
          </div>
        </div>
        <div class="label-list">
          <ul>
            <li
              :class="['label-list-item', item.isSelected ? 'is-selected' : '']"
              v-for="(item, index) in hopeList"
              :key="index"
              @click="chooseLabel('hope', index)"
            >
              <p># {{ item.label_name }} #</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 中间空白 -->
      <div class="none"></div>
      <!-- 联系我们 -->
      <div class="form">
        <div class="label-title">
          <div class="shu"></div>
          <div class="label-title-text">
            <p>联系我们</p>
          </div>
        </div>
        <textarea
          class="input"
          placeholder="如需了解更多详细内容，请留下您的姓名和联系方式"
          v-model="textarea"
        />
        <button class="submit" @click="formSubmit">提交</button>
      </div>
    </div>

    <!-- 往期回顾 -->
    <div class="list" v-if="tabIndex == 0">
      <!-- 专栏视频 -->
      <!-- <div> -->
      <!-- 头部标题 -->
      <!-- <div class="list-header">
          <div class="header-icon">
            <img src="../../static/projectBriefing/images/sp_04.png" alt="" />
          </div>
          <div class="header-title">专栏视频</div>
        </div> -->
      <!-- 视频列表 -->
      <!-- <ul>
          <li
            v-for="(item, index) in videoList"
            :key="index"
            @click="playVideo(index)"
            v-if="item.type == 1"
          >
            <div class="li-left">
              <img class="banner" :src="item.poster" alt="" />
            </div>
            <div class="li-right">
              <div class="li-title">
                <p :class="video.index == index ? 'active' : ' '">
                  {{ item.video_title }}
                </p>
              </div> -->
      <!-- <div class="li-intro">
              <p :class="video.index == index ? 'active' : ' '">
                {{ item.desc }}
              </p>
            </div> -->
      <!-- <div class="li-datetime">
                <p :class="['date', video.index == index ? 'active' : ' ']">
                  {{ item.create_date }}
                </p> -->
      <!-- <p :class="['time', video.index == index ? 'active' : ' ']">
                {{ item.time }}
              </p> -->
      <!-- </div>
            </div>
          </li>
        </ul>
      </div> -->
      <!-- 往期视频 -->
      <div>
        <!-- 头部标题 -->
        <div class="list-header">
          <div class="header-icon">
            <img src="../../static/projectBriefing/images/sp_04.png" alt="" />
          </div>
          <div class="header-title">往期回顾</div>
        </div>
        <!-- 视频列表 -->
        <ul>
          <li
            v-for="(item, index) in videoList"
            :key="index"
            @click="playVideo(index)"
          >
            <div class="li-left">
              <img class="banner" :src="item.poster" alt="" />
            </div>
            <div class="li-right">
              <div class="li-title">
                <p :class="video.index == index ? 'active' : ' '">
                  {{ item.video_title }}
                </p>
              </div>
              <!-- <div class="li-intro">
              <p :class="video.index == index ? 'active' : ' '">
                {{ item.desc }}
              </p>
            </div> -->
              <div class="li-datetime">
                <p :class="['date', video.index == index ? 'active' : ' ']">
                  {{ item.create_date }}
                </p>
                <!-- <p :class="['time', video.index == index ? 'active' : ' ']">
                {{ item.time }}
              </p> -->
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import jssdkAPI from "../api/JSSDK";
import wechatAPI from "../api/weChatOfficialAcount";
import videoBriefingAPI from "../api/videoBriefing";
import { Toast } from "vant";

export default {
  name: "video",
  data() {
    return {
      videoID:'',
      code: "", //微信授权返回的code值，用来获取用户信息
      video: {}, //当前播放的视频信息
      videoList: [], //视频列表
      likeList: [], //标签列表(喜欢本期)
      hopeList: [], //标签列表(希望看到更多)
      tabIndex: 0, //tab切换框下标
      textarea: "", //文本框的值
      openId: "", //用户openId
      userName: "", //用户姓名
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: true,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: "auto",
        language: "zh-CN",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: "16:9",
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [
          {
            //类型
            type: "video/mp4",
            //url地址
            src: "",
          },
        ],
        //你的封面地址
        poster: "",
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true,
        },
      },
    };
  },
  methods: {
    //tab列表切换
    tabSwitch(tabIndex) {
      this.tabIndex = tabIndex;
    },
    chooseLabel(type, index) {
      if (type == "like") {
        this.likeList[index].isSelected = !this.likeList[index].isSelected;
      } else {
        this.hopeList[index].isSelected = !this.hopeList[index].isSelected;
      }
    },
    //获取视频列表信息
    videoInfoList() {
      // videoID  ==参数id  选择
      console.log(this.$route.query.videoID)
      this.$axios
        .get(videoBriefingAPI.videoBriefingAPI.allvideoInfoList)
        .then((res) => {
          if (res.data.statusCode == 1000) {
            let videoList = res.data.data;
            for (let i = 0; i < videoList.length; i++) {
              videoList[i].create_date = videoList[i].create_date.split(" ")[0];
            }
            this.videoList = res.data.data;
            if(this.$route.query.videoID){
              for(var a = 0 ; a < res.data.data.length ; a++){
                if(res.data.data[a].video_id == this.$route.query.videoID){
                   this.video = this.videoList[a];
                   console.log( this.video)
                   this.playVideo(a);
                }
              }
            }else{
              this.video = this.videoList[0];
              this.playVideo(0);

            }
            
          } else {
            console.log("error");
            console.log(res);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    //获取标签列表信息
    getLabelList() {
      this.$axios
        .get(videoBriefingAPI.videoBriefingAPI.labelList)
        .then((res) => {
          if (res.data.statusCode == 1000) {
            console.log(res);

            let list = res.data.data;
            this.likeList = this.addColumn(list.likeData, "isSelected", false);
            this.hopeList = this.addColumn(list.hopeData, "isSelected", false);
          } else {
            console.log("error:" + res);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    //向数组中的每一个对象添加键值对
    addColumn(array, key, value) {
      for (let i = 0; i < array.length; i++) {
        array[i][key] = value;
      }
      return array;
    },
    splicString(array, field, value, finalField) {
      let str = "";
      for (let i = 0; i < array.length; i++) {
        if (array[i][field] == value) {
          str += array[i][finalField] + ",";
        }
      }
      return str.substring(0, str.length - 1);
    },
    //提交表单
    formSubmit() {
      const textarea = this.textarea;
      const userName = this.userName == null ? "undefined" : this.userName;
      const openId = this.openId == null ? "undefined" : this.openId;
      const videoId = this.video.video_id;
      const likeLabel = this.splicString(
        this.likeList,
        "isSelected",
        true,
        "label_id"
      );
      const hopeLabel = this.splicString(
        this.hopeList,
        "isSelected",
        true,
        "label_id"
      );
      if (likeLabel == "" && hopeLabel == "" && textarea == "") {
        Toast.fail("亲，给个评价再提交吧");
      } else {
        this.$axios
          .get(videoBriefingAPI.videoBriefingAPI.submitFeedBack, {
            params: {
              content: textarea,
              openId: openId,
              userName: userName,
              videoId: videoId,
              likeLabel: likeLabel,
              hopeLabel: hopeLabel,
            },
          })
          .then((res) => {
            if (res.data.statusCode == 1000) {
              Toast.success("提交成功");
              sensors.track("submitFeedBack", {
                content: textarea,
                openId: openId,
                userName: userName,
                videoId: videoId,
                likeLabel: likeLabel,
                hopeLabel: hopeLabel,
                isSuccess: "1",
                faildReason: "",
              });
              this.textarea = "";
            } else {
              Toast.fail("提交失败");
              sensors.track("submitFeedBack", {
                content: textarea,
                openId: openId,
                userName: userName,
                videoId: videoId,
                likeLabel: likeLabel,
                hopeLabel: hopeLabel,
                isSuccess: "0",
                faildReason: "提交失败",
              });
            }
          })
          .catch((res) => {
            console.log(res);
          });
      }
    },
    //视频切换
    async playVideo(index) {
      this.video = this.videoList[index];
      this.video.index = index;
      this.playerOptions.sources[0].src = this.videoList[index].video_src;
      this.playerOptions.poster = this.videoList[index].poster;
      setTimeout(()=>{
        document.addEventListener(
          "WeixinJSBridgeReady",
          () => {
            document.getElementById("vjs_video_418_html5_api").play();
          },
          false
        );
      },2000);
      this.wxConfig();

      sensors.track("Clickplaymoviebutton", {
        module_name: this.videoList[index].title,
      });
    },

    //微信公众号js配置文件
    wxConfig() {
      this.$axios
        .get(jssdkAPI.jssdk.signature, {
          params: { url: window.location.href.split("#")[0] },
        })
        .then((res) => {
          // console.log(res);
          wx.config({
            debug: false,
            appId: "wx6c8bdb72dba32bd2", //后台获取
            timestamp: res.data.timestamp, //后台获取
            nonceStr: res.data.noncestr, //后台获取
            signature: res.data.signature, //后台获取
            jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareAppMessage",
            ],
          });
          const video = this.video;
          // console.log(video);
          wx.ready(function () {
            //微信好友及qq好友分享
            wx.updateAppMessageShareData({
              title: video.video_title, // 分享标题
              desc: video.video_desc, // 分享描述
              link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: video.poster, // 分享图标
              success: function () {
                // 设置成功
              },
            });

            //qq空间及朋友圈分享
            wx.updateTimelineShareData({
              title: video.video_title, // 分享标题
              link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: video.poster, // 分享图标
              success: function () {
                // 设置成功
              },
            });
          });
          // wx.checkJsApi({
          //   jsApiList: ["updateAppMessageShareData"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
          //   success: function (res) {
          //     console.log(res);
          //     // 以键值对的形式返回，可用的api值true，不可用为false
          //     // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
          //   },
          // });
        })
        .catch((res) => {
          // console.log(res);
        });
    },

    //登录
    login() {
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx6c8bdb72dba32bd2&redirect_uri=" +
        encodeURIComponent(window.location.href) +
        "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
    },

    //调用接口授权登录并获取用户信息
    getUserInfo(code) {
      this.$axios
        .get(wechatAPI.wechatAPI.login, { params: { code: code } })
        .then((res) => {
          console.log(res);
        })
        .catch((res) => {
          console.log(res);
        });
    },

    //分享
    share() {
      // const video = this.video;
      //     wx.ready(function () {
      //       //需在用户可能点击分享按钮前就先调用
      //       wx.updateAppMessageShareData({
      //         title: video.title, // 分享标题
      //         desc: video.desc, // 分享描述
      //         link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      //         imgUrl: video.poster, // 分享图标
      //         success: function (res) {
      //           // 设置成功
      //         },
      //       });
      //     });
    },
  },
  created() {
    if (window.location.href.indexOf("state") !== -1) {
      // 此方法仅供参考！！！
      this.code = window.location.href
        .split("?")[1]
        .split("=")[1]
        .split("&")[0];
    }

    if (this.code) {
      // 存在 code 直接调用接口
      this.getUserInfo(this.code);
    }
    const openId =
      this.$route.query.openId == undefined ? null : this.$route.query.openId;
    const userName = decodeURIComponent(
      this.$route.query.userName == undefined
        ? null
        : this.$route.query.userName
    );
    this.openId = openId;
    this.userName = userName;
    sensors.registerPage({
      platform_type: "项目播报",
    });
    sensors.setProfile({
      OpenID: openId,
      Name: userName,
    });
    sensors.quick("autoTrack");
    sensors.track("Watch_userName", {
      userName: userName,
    });
    this.wxConfig();
    this.videoInfoList();
    this.getLabelList();
  },
  mounted() {
    
    // this.$nextTick(() => {
    //   console.log(this.$refs.videoPlayer.player);
      
    //   if (typeof WeixinJSBridge === "undefined") {
    //     //未执行WeixinJSBridge 开始监听 WeixinJSBridge
    //     document.addEventListener(
    //       "WeixinJSBridgeReady",
    //       () => {
    //         document.getElementById("vjs_video_418_html5_api").play();
    //       },
    //       false
    //     );
    //   } else {
    //     this.$refs.videoPlayer.player.play();
    //     //已经执行 使用 getNetworkType 调用获取网络类型后执行
    //     // WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
    //     //   alert(netType[e.err_msg]);
    //     //   document.getElementById("vjs_video_418_html5_api").play();
    //     // });
    //   }
    // });
  },
};
</script>
<style scoped>
/* 视频 */
.video {
  width: 7.5rem;
  height: 4.3rem;
}
.video video {
  width: 7.5rem;
  height: 100%;
}

/* 切换 */
.tab {
  width: 6.7rem;
  height: 0.8rem;
  padding: 0 0.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e9e9e9;
}
.tab .tab-item {
  width: 50%;
  height: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tab .tab-item .tab-item-item {
  height: 0.8rem;
  display: flex;
  align-items: center;
}
.tab .tab-item .tab-item-item p {
  font-size: 0.28rem;
  color: #666;
}
.tab .tab-item .tab-item-item .icon {
  width: 0.4rem;
  height: 0.4rem;
}
.tab .tab-item .tab-item-item div {
  display: flex;
  align-items: center;
}
.tab .tab-item .tab-item-item div p {
  margin-left: 0.1rem;
}
.tab .tab-item .comment {
  margin-left: 0.7rem;
}
.tab .tab-item .thumb {
  margin-right: 0.7rem;
}
.tab .tab-item .show {
  position: relative;
  display: flex;
  justify-content: center;
}
.tab .tab-item .show p {
  color: #333;
}
.tab .tab-item .show .underline {
  position: absolute;
  bottom: 0;
  width: 0.46rem;
  max-height: 0.06rem;
}
/* 详情 */
/* 简介部分 */
.desc {
  width: 100%;
}
.desc .title {
  width: 6.7rem;
  margin: 0 auto;
  padding: 0.3rem 0;
  font-size: 0.36rem;
  color: #333;
}
.desc .intro {
  width: 6.7rem;
  margin: 0 auto;
  padding-bottom: 0.3rem;
  font-size: 0.22rem;
  color: #666;
  line-height: 0.4rem;
}
/* 标签模块 */
.label {
  width: 6.7rem;
  margin: 0 auto;
  padding: 0.3rem 0;
}
.label-title {
  display: flex;
  align-items: center;
  width: 100%;
  height: 0.5rem;
}
.label-title .shu {
  width: 0.06rem;
  height: 0.34rem;
  background-color: #f8c800;
  border-radius: 50px;
}
.label-title .label-title-text {
  margin-left: 0.2rem;
}
.label-title .label-title-text p {
  font-size: 0.28rem;
  color: #333;
}
.label .label-list {
  width: 100%;
}
.label .label-list ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
}
.label .label-list ul .label-list-item {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.3rem;
  padding: 0 0.31rem;
  height: 0.5rem;
  border: 0.01rem solid #d3d3d3;
  border-radius: 5px;
}
/* .label .label-list ul .label-list-item:nth-child(3n-1){
  margin: 0 .35rem;
} */
.label .label-list ul .label-list-item p {
  font-size: 0.24rem;
  color: #666;
}
.label .label-list ul .is-selected {
  background-color: rgba(250, 189, 0, 0.1);
  border: 0.01rem solid #fabd00;
}
.label .label-list ul .is-selected p {
  color: #fabd00;
}
/* 表单 */
.form {
  width: 6.7rem;
  margin: 0 auto;
  padding: 0.3rem 0 0.73rem;
}
.form .input {
  padding: 0.26rem;
  margin-top: 0.3rem;
  width: 6.16rem;
  height: 1.5rem;
  background-color: #f9f9f9;
  border: 0.01rem solid #eaeaea;
  border-radius: 5px;
  font-size: 0.2rem;
}
.form .submit {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0.2rem;
  margin-top: 0.2rem;
  width: 6.7rem;
  height: 0.6rem;
  font-size: 0.2rem;
  background-color: #fabd00;
  border-radius: 30px;
  border: none;
}
/* 隔行 */
.none {
  width: 7.5rem;
  height: 0.1rem;
  background-color: #f9f9f9;
}
/* 视频列表 */
.list {
  width: 100%;
}
.list-header {
  width: 6.7rem;
  height: 0.5rem;
  margin: 0 auto;
  padding-top: 0.3rem;
  display: flex;
  align-items: center;
}
.list-header .header-icon {
  width: 0.5rem;
  height: 0.5rem;
  display: flex;
  align-items: center;
}
.list-header .header-icon img {
  width: 0.44rem;
  height: 0.35rem;
}
.list-header .header-title {
  height: 0.5rem;
  margin-left: 0.2rem;
  font-size: 0.3rem;
  color: #333;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.list ul {
  width: 100%;
}
.list ul li {
  width: 6.7rem;
  height: 1.35rem;
  margin: 0.4rem auto 0;
  display: flex;
  justify-content: space-between;
}
.list ul li .li-left {
  width: 2.4rem;
  height: 1.35rem;
}
.list ul li .li-left .banner {
  width: 2.4rem;
  height: 1.35rem;
  border-radius: 0.05rem;
}
.list ul li .li-right {
  width: 4rem;
  height: 1.35rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.list ul li .li-right .li-title,
.li-intro,
.li-datetime {
  width: 100%;
  display: flex;
}
.list ul li .li-right .li-title,
.li-intro p {
  width: 100%;
  word-wrap: break-word;
  /* display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; */
}
.list ul li .li-right .li-title p {
  font-size: 0.28rem;
  color: #333;
}
.list ul li .li-right .li-intro p {
  font-size: 0.2rem;
  color: #666;
}
.list ul li .li-right .li-datetime p {
  font-size: 0.2rem;
  color: #999;
}
.list ul li .li-right .li-datetime .time {
  margin-left: 0.3rem;
}
.active {
  color: #f8c800 !important;
}
.inactive {
  color: #ccc;
}
</style>


// WEBPACK FOOTER //
// src/pages/allvideo.vue